module.exports = __webpack_public_path__ + "img/kommune-1027.c015ac6b.svg";